// customSelect.js

export function initializeCustomSelect(selectId) {
  const customSelectClass = 'custom-select';
  const customSelect = document.querySelector(`#${selectId}-custom-select`);
  const customSelectTrigger = customSelect?.querySelector(`
    .${customSelectClass}__trigger
  `);
  const customOptions = customSelect?.querySelector(`
    .${customSelectClass}__options
  `);
  const selectedDialCode = customSelectTrigger?.querySelector(`
    .selected-dial-code
  `);
  const selectedFlag = customSelectTrigger?.querySelector('.iti__flag');

  customSelectTrigger?.addEventListener('click', () => {
    customSelect?.classList.toggle('open');
  });

  customOptions?.addEventListener('click', (event) => {
    const option = event.target.closest(`.${customSelectClass}__option`);
    if (!option) return;

    const dialCode = option?.getAttribute('data-value');
    const flagClass = option?.getAttribute('data-flag');

    selectedDialCode.textContent = dialCode;
    selectedFlag.className = `iti__flag iti__${flagClass}`;
    customSelect?.classList.remove('open');
  });

  document.addEventListener('click', (event) => {
    if (!customSelect?.contains(event.target)) {
      customSelect?.classList.remove('open');
    }
  });
}
